import React from 'react';
import { Route, Switch } from 'react-router-dom';

import GiftManagement from 'features/bonusProgram/view/desktop/GiftManagement';
import GiftRequests from 'features/bonusProgram/view/desktop/GiftRequests';
import CreatePromotions from 'features/bonusProgram/view/desktop/Promotions/CreatePromotions/CreatePromotions';
import Promotions from 'features/bonusProgram/view/desktop/Promotions';

const BonusProgramModule = (
  <Route key="/bonus-promo" path="/bonus-promo">
    <Switch>
      <Route
        key="/bonus-promo/promotions/create/:id"
        path="/bonus-promo/promotions/create/:id"
        component={CreatePromotions}
      />
      <Route key="/bonus-promo/promotions/create" path="/bonus-promo/promotions/create" component={CreatePromotions} />
      <Route key="/bonus-promo/management/:id" path="/bonus-promo/management/:id" component={GiftManagement} />
      <Route key="/bonus-promo/management" path="/bonus-promo/management" component={GiftManagement} />
      <Route key="/bonus-promo/requests" path="/bonus-promo/requests" component={GiftRequests} />
      <Route key="/bonus-promo/promotions" path="/bonus-promo/promotions" component={Promotions} />
    </Switch>
  </Route>
);

export default BonusProgramModule;
